import { track } from "@homeinstead/analytics";
import { parseUtmParameters } from "@homeinstead/analytics/tracking";
import { EventName } from "@homeinstead/shared";
import { useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

/**
 * Tracks UTM parameters in the URL.
 * @returns void
 * @deprecated We get UTM tracking for free with Segment. Remove this after
 * verifying impact and/or updating downstream systems to pull UTM values from
 * event context.
 * @see https://www.twilio.com/docs/segment/connections/spec/track#context
 */
function useTrackUtmParams() {
  const hasTracked = useRef(false);
  const searchParams = useSearchParams();

  useEffect(() => {
    if (hasTracked.current) {
      return;
    }

    hasTracked.current = true;
    const utmParams = parseUtmParameters(searchParams.toString());

    if (Object.keys(utmParams).length === 0) {
      return;
    }

    track(EventName.URL_PARAMS, { params: utmParams });
  }, [searchParams]);
}

export { useTrackUtmParams };
